import { useMutation } from "@tanstack/react-query";
import { instance } from "@/apis";

export type DissatisfactionType =
  | "REPORT_A_BUG"
  | "UNTRUE"
  | "INCOMPLETE_RESPONSE"
  | "REPORT_CONTENT"
  | "ETC";

export interface ChatFeedbackBody {
  isPositive: boolean;
  reason: string;
  dissatisfactionType?: DissatisfactionType;
}

const useChatFeedbackMutation = () =>
  useMutation({
    mutationFn: ({
      chatId,
      chatHistoryId,
      body,
    }: {
      chatId: number;
      chatHistoryId: number;
      body: ChatFeedbackBody;
    }) =>
      instance.put(`/api/df/user/chat/${chatId}/feedback/${chatHistoryId}`, body),
  });

export default useChatFeedbackMutation;
